<template>
  <WdsInput
    v-model="nameValue"
    data-test="custom-field-name"
    :disable="disabled"
    :label="$t('Name')"
    :error="error"
  />
</template>

<script setup lang="ts">
import { WdsInput } from '@worksome/wds-components'
import { useVModel } from '@vueuse/core'
import { $t } from '@/composables/translation'

interface Props {
  modelValue?: string
  error?: string
  disabled: boolean
}

const props = defineProps<Props>()

const emit = defineEmits(['update:modelValue'])

const nameValue = useVModel(props, 'modelValue', emit)
</script>
